import { CommonModule } from '@angular/common'
import { Component, OnInit } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'
import { TranslateModule } from '@ngx-translate/core'
import { StateService } from '../../services/state.service'

@Component({
  selector: 'app-error',
  standalone: true,
  imports: [CommonModule, MatIconModule, TranslateModule],
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
})
export class ErrorComponent implements OnInit {
  error?: any
  showError = false

  constructor(private stateService: StateService) {
    // do nothing
  }

  ngOnInit(): void {
    this.stateService.isLoading$.next(false)
  }
}
